module.exports = __webpack_public_path__ + "static/media/scheduled-appointments.208de8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/scheduled-appointments.svg
// module id = 877
// module chunks = 0